module.exports = __webpack_public_path__ + "img/contact.3fe418eb.png";